import React from "react";
import { Row, Col, Form } from "react-bootstrap";

export const DomesticCountryForm = ({
  countryCode,
  displayName,
  countryCodeTouched,
  displayNameTouched,
  handleCountryCodeChange,
  handleDisplayNameChange,
  handleCountryCodeBlur,
  handleDisplayNameBlur,
  validateCountryCode,
  validateDisplayName,
  localized,
}) => {
  const countryCodeError = countryCodeTouched
    ? validateCountryCode(countryCode)
    : null;

  const displayNameError = displayNameTouched
    ? validateDisplayName(displayName)
    : null;

  return (
    <div className="d-flex flex-column gap-4">
      <Form.Group as={Row} controlId="countryCode">
        <Form.Label column sm="4">
          {localized.DomesticCountriesCountryCode} *
        </Form.Label>

        <Col sm="8">
          <Form.Control
            type="text"
            name="countryCode"
            value={countryCode}
            onChange={handleCountryCodeChange}
            onBlur={handleCountryCodeBlur}
            maxLength={2}
            style={{
              height: "4.8rem",
              fontSize: "1.8rem",
              textTransform: "uppercase",
            }}
            required
            isInvalid={!!countryCodeError}
          />

          <Form.Control.Feedback type="invalid">
            {countryCodeError || localized.DomesticCountriesRequiredCountry}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="displayName">
        <Form.Label column sm="4">
          {localized.DomesticCountriesDisplayName} *
        </Form.Label>

        <Col sm="8">
          <Form.Control
            type="text"
            name="displayName"
            value={displayName}
            onChange={handleDisplayNameChange}
            onBlur={handleDisplayNameBlur}
            maxLength={100}
            style={{
              height: "4.8rem",
              fontSize: "1.8rem",
            }}
            required
            isInvalid={!!displayNameError}
          />

          <Form.Control.Feedback type="invalid">
            {displayNameError || localized.DomesticCountriesNameRequired}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
    </div>
  );
};
